import { createAsyncThunk } from '@reduxjs/toolkit';
import { MyThunkApiConfig } from '../../types';

export const getJobDetailsAction = createAsyncThunk<
  any,
  { graphqlFunction: (params: any) => Promise<any>; params: any },
  MyThunkApiConfig
>('job/jobDetails', async (inputData, { rejectWithValue }) => {
  const { graphqlFunction, params } = inputData;
  try {
    const response = await graphqlFunction(params);
    return response?.getJobDetails || response?.data?.getJobDetails;
  } catch (error) {
    return rejectWithValue({ error: error.message });
  }
});

export const jobDetailsSaveCrewNotesAction = createAsyncThunk<
  boolean,
  { graphqlFunction: (params: any) => Promise<any>; params: any },
  MyThunkApiConfig
>('job/jobDetails-save-crew-notes', async (inputData, { rejectWithValue }) => {
  const { graphqlFunction, params } = inputData;
  try {
    await graphqlFunction(params);
    return true;
  } catch (error) {
    return rejectWithValue({ error: error.message });
  }
});
